import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/footer.component";
import Newnavbar from "../components/newnavbar";
import LandingPageImg from "../assets/images/landing.svg";

const Landing = () => {
  return (
    <>
      <Newnavbar />
      <div className="py-24 w-100" style={{ width: "100%" }}>
        <br />
        <div className="d-flex flex-column font-link align-items-center my-3">
          <h1
            className="display-1"
            style={{ fontWeight: "bolder", marginBottom: "20px" }}
          >
            InterviewIQ
          </h1>
          <p
            className="fs-5 text-muted"
            style={{ marginBottom: "10px", letterSpacing: "1px" }}
          >
            AI-Powered Interview Emotion Analysis
          </p>
          <p className="fs-4" style={{ marginBottom: "60px" }}>
            Sharpen &nbsp;your &nbsp;interview &nbsp;skills &nbsp;with &nbsp;real-time &nbsp;AI &nbsp;feedback
          </p>

          <div className="d-flex gap-3" style={{ gap: "20px", marginBottom: "20px" }}>
            <Link to="/video">
              <button type="button" className="btn btn-dark py-2 px-4">
                🎥 Video Interview
              </button>
            </Link>
            <Link to="/audio">
              <button type="button" className="btn btn-outline-dark py-2 px-4">
                🎙️ Audio Interview
              </button>
            </Link>
          </div>
        </div>

        <div>
          <div className="landing-img" style={{ width: "100%" }}>
            <img
              src={LandingPageImg}
              style={{ width: "100%", height: "600px" }}
              alt="Landing"
            />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Landing;
